"use client";
import {
  getInjectedConnector,
  hasInjectedProvider
} from "./chunk-MBBGZGXF.js";

// src/wallets/walletConnectors/zealWallet/zealWallet.ts
var zealWallet = () => ({
  id: "zeal",
  name: "Zeal",
  iconUrl: async () => (await import("./zealWallet-URNQ2AWF.js")).default,
  iconBackground: "#fff0",
  installed: hasInjectedProvider({ flag: "isZeal" }),
  downloadUrls: {
    browserExtension: "https://zeal.app"
  },
  extension: {
    instructions: {
      learnMoreUrl: "https://zeal.app/",
      steps: [
        {
          description: "wallet_connectors.zeal.extension.step1.description",
          step: "install",
          title: "wallet_connectors.zeal.extension.step1.title"
        },
        {
          description: "wallet_connectors.zeal.extension.step2.description",
          step: "create",
          title: "wallet_connectors.zeal.extension.step2.title"
        },
        {
          description: "wallet_connectors.zeal.extension.step3.description",
          step: "refresh",
          title: "wallet_connectors.zeal.extension.step3.title"
        }
      ]
    }
  },
  createConnector: getInjectedConnector({ flag: "isZeal" })
});

export {
  zealWallet
};
